import React from "react";
import Tabs from '../Tabs/Tabs';
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DeviceToolbar from "./DeviceToolbar";
import PageBuilderPage from "./PageBuilderPage";
import PageBuilderStore from "./stores/PageBuilderStore";
import PageBuilderActions from "./actions/PageBuilderActions";
import MultiSelect from "../Selects/MultiSelect";

class PageBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getStateFromStores();
    this._onChange = this._onChange.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    PageBuilderStore.addChangeListener(this._onChange);
    PageBuilderActions.init(this.props);
    this.setState({
      errors: null,
      loading: false,
      mounted: true,
    });
  };

  getStateFromStores() {
    return {
      name: PageBuilderStore.getName(),
      rows: PageBuilderStore.getRows(),
      mode: PageBuilderStore.getMode(),
      charts: PageBuilderStore.getCharts(),
      widgets: PageBuilderStore.getWidgets(),
      activeTab: PageBuilderStore.getActiveTab(),
      activeRowId: PageBuilderStore.getActiveRowId(),
      activeColumnId: PageBuilderStore.getActiveColumnId(),
      highlightColumnId: PageBuilderStore.getHighlightColumnId(),
      highlightRowId: PageBuilderStore.getHighlightRowId(),
      openMenuRowId: PageBuilderStore.getOpenMenuRowId(),
      resizeRowId: PageBuilderStore.getResizeRowId(),
      forceUpdate: PageBuilderStore.getForceUpdate(),
      role_ids: PageBuilderStore.getRoleIds(),
    }
  }

  render() {
    return (
      <div className="page-builder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <div className="tab-content content-wrapper">
            <ModalButtons loading={this.state.loading} buttons={this.buttons()} />
            {this.renderErrors()}
            {
              this.state.activeTab === 'general'
              ?
                <div className="row">
                  <div className="col-lg-3" style={{marginTop: '-15px'}}>
                    <div className="form-group">
                      <label>{I18n.t('name')}*</label>
                      <input type="text" name="name" value={this.state.name} onChange={this.onChangeName} className={this.renderFieldClasses('name')} />
                      {this.renderFieldErrors('name')}
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <DeviceToolbar mode={this.state.mode} activeRowId={this.state.activeRowId} resizeRowId={this.state.resizeRowId} />
                    <PageBuilderPage {...this.state} pageBuilderMounted={this.state.mounted} pageBuilderInitialized={this.state.initialized} />
                  </div>
                </div>
              :
              null
            }
            {
              this.state.activeTab === 'roles'
              ?
              <MultiSelect
                header_primary="name"
                  inputs={this.props.roles.map((role) => {return {label_primary: role.name, id: role.id} })}
                  selected_inputs={this.state.role_ids}
                  onChange={PageBuilderActions.changeRoles}
                />
              :
              null
            }
            <LoadingSpinner show={this.state.loading} />
          </div>
        </div>
      </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: PageBuilderActions.changeTab,
        },
        {
          tabName: I18n.t('roles'),
          targetName: 'roles',
          classes: this.state.activeTab === 'roles' ? 'active' : null,
          changeHandler: PageBuilderActions.changeTab,
        },
      ]
    );
  };

  renderErrors() {
    if (this.state.errors) {
      var self = this;
      var errorMessages = []
      var idx = 0;
      var errorFields = Object.keys(this.state.errors)
      errorFields.map((errorField) => {
        var errors = this.state.errors[errorField]
        if (errors && errors.length > 0) {
          errors.map((error) => {
            idx = idx + 1;
            errorMessages.push(<li key={errorField + idx}>{self.capitalize(errorField)} {error}</li>)
          });
        }
      });

      return (
        <div className="row">
          <div className="col-sm-12">
            <div className="alert alert-danger">
              <ul>{errorMessages}</ul>
            </div>
          </div>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.state.errors && Object.keys(this.state.errors).length && this.state.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors[field]) {
      var idx = 0;
      var errors = <li key={idx}><b>&#x2022;</b> {this.state.errors[field][0]}</li>;

      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  /**
  * Change handlers
  */

  _onChange() {
    this.setState(this.getStateFromStores());
  }

  onChangeName(event) {
    if (event && event.stopPropagation && event.preventDefault) {
      event.stopPropagation()
      event.preventDefault();
    }

    PageBuilderActions.setName(event.target.value);
  }

  onSave() {
    var self = this;

    this.setState({loading: true});

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.form_action,
      data: {
        dashboard: {
          name: this.state.name,
          rows: this.state.rows,
          role_ids: this.state.role_ids,
        }
      }
    }).done((data) => {
      if (data.errors && Object.keys(data.errors).length) {
        this.setState({
          loading: false,
          errors: data.errors
        })
      } else {
        this.setState({loading: false});
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(I18n.t('dashboard_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('dashboard_saved_successfully'));
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    });
  }

  /**
  * Helper functions
  */

  buttons () {
    var self = this;
    return [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation();
          e.preventDefault();

          self.onSave();
        }
      }
    ];
  }

  capitalize (s)  {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

};

export default PageBuilder
